<template>
    <div class="landDetail">
        <leftnav class="fl" mkcode="A" :itemcode="yj_itemcode"></leftnav>
        <div class="index_left" :style="isCollapse ? 'margin-left: 0;width:100%' : ''">
            <govheader></govheader>
            <div class="index_left_centerpage">
                <div class="whitebox py-4">
                    <div class="bgwidth" style="height: auto; padding-bottom: 40px">
                        <table cellspacing="0" cellpadding="4" border="0" class="detail_table  margin-x-auto" width="90%">
                            <tr v-show="pageType == 2">
                                <td class="thead font-bold" colspan="1">复合筛选条件数</td>
                                <td class="thead" colspan="1"><el-rate :disabled="true" :colors="['#333','#333','#333']" v-model="baseinfo.rate"></el-rate></td>
                                <td class="thead font-bold" colspan="2">符合条件原因</td>
                                <td class="thead" colspan="3">
                                   <div class="text-left">
                                     <p>1.项目名称含重点行业关键词</p>
                                     <p>2.土地面积高于最低监测标准；</p>
                                     <p>3.行业分类属于重点行业范围；</p>
                                   </div>
                                </td>
                            </tr>
                            <tr>
                                <th class="thead font-bold" colspan="7">供地结果信息</th>
                            </tr>
                            <tr>
                                <td class="col1 font-bold">项目名称:</td>
                                <td class="cols3" colspan="6">
                                    {{ baseinfo.projectName }}@Model.
                                </td>
                            </tr>
                            <tr>
                                <td class="col1 font-bold">项目位置:</td>
                                <td class="cols3" colspan="6">
                                    {{ baseinfo.projectLocation }}@Model.
                                </td>
                            </tr>
                            <tr>
                                <td class="col1 font-bold">项目城市:</td>
                                <td class="col2" colspan="3">
                                    {{ baseinfo.province }}{{ baseinfo.city
                                    }}{{ baseinfo.county }}
                                </td>
                                <td class="col3 font-bold">电子监管号：</td>
                                <td class="col4" colspan="2">{{ baseinfo.ecNumber }}</td>
                            </tr>
                            <tr>
                                <td class="col1 font-bold">批准单位:</td>
                                <td class="col2" colspan="3">{{ baseinfo.approvalCompany }}</td>
                                <td class="col3 font-bold">合同签订日期:</td>
                                <td class="col4" colspan="2">{{ baseinfo.contractTime }}</td>
                            </tr>
                            <tr>
                                <td class="col1 font-bold">土地使用权人:</td>
                                <td class="cols3" colspan="3">{{ baseinfo.landOwner }}</td>
                                <td class="col1 font-bold">投资主体:</td>
                                <td class="cols3" colspan="2">{{ baseinfo.investment }}</td>
                                
                            </tr>
                            <tr>
                                <td class="col1 font-bold">土地用途:</td>
                                <td class="col2" colspan="3">{{ baseinfo.bigLandUse }}</td>
                                <td class="col1 font-bold">土地使用年限:</td>
                                <td class="col2" colspan="2">{{ baseinfo.useYears }}</td>
                            </tr>
                            <tr>
                                <td class="col3 font-bold">行业分类:</td>
                                <td class="col4" colspan="3">
                                    {{ baseinfo.smallIndustry }}
                                </td>
                                <td class="col1 font-bold">土地级别:</td>
                                <td class="col2" colspan="2">{{ baseinfo.landLevel }}</td>
                            </tr>
                            <tr>
                                <td class="col1 font-bold">面积(亩<!--公顷-->):</td>
                                <td class="col2" colspan="3">{{ baseinfo.nSizeUnit }}</td>
                                <td class="col3 font-bold">成交价格(万元):</td>
                                <td class="col4" colspan="2">{{ baseinfo.nPriceUnit }}</td>
                            </tr>
                            <tr>
                                <td class="col1 font-bold">约定容积率:</td>
                                <td class="font-bold">下限:</td>
                                <td>{{ baseinfo.volumeLower }}</td>
                                <td class="font-bold">上限:</td>
                                <td>{{ baseinfo.volumeUpper }}</td> 
                                <td class="col3 font-bold">供地方式:</td>
                                <td class="col4">
                                    {{ baseinfo.bigSupplyMode }} {{ baseinfo.smallSupplyMode }}
                                </td>
                            </tr>
                            <tr>
                                <td class="col1 font-bold">分期支付约定:</td>
                                <td class="cols3" colspan="4" style="margin: 0;padding: 0;">
                                    <table cellspacing="0" cellpadding="2" border="0" class="paytable" width="100%">
                                        <tr>
                                            <td class="pcol1 font-bold">支付期号</td>
                                            <td class="pcol2 font-bold">约定支付日期</td>
                                            <td class="pcol3 font-bold">约定支付金额(万元)</td>
                                            <td class="pcol4 font-bold">备注</td>
                                        </tr>
                                        <tr v-for="(payment, i) in baseinfo.paymentList" :key="i">
                                            <td class="pcol1">{{ payment.number }}</td>
                                            <td class="pcol2">{{ payment.payTime }}</td>
                                            <td class="pcol3">{{ payment.landOwner }}</td>
                                            <td>{{ payment.memo }}</td>
                                        </tr>
                                    </table>
                                </td>
                                <td class="col3 font-bold">土地来源:</td>
                                <td class="col4" colspan="2">{{ baseinfo.source }}</td>
                            </tr>
                            
                            <tr>
                                <td class="col3 font-bold">约定交地时间:</td>
                                <td class="col4" colspan="6">{{ baseinfo.deliveryTime }}</td>
                            </tr>
                            <tr>
                                <td class="col1 font-bold">约定开工时间:</td>
                                <td class="col2" colspan="4">{{ baseinfo.startTime }}</td>
                                 <td class="col1 font-bold">实际开工时间:</td>
                                <td class="col2">{{ baseinfo.realStartTime }}</td>
                                
                            </tr>
                            <tr>
                                <td class="col3 font-bold">约定竣工时间:</td>
                                <td class="col4" colspan="4">{{ baseinfo.endTime }}</td>
                                <td class="col3 font-bold">实际竣工时间:</td>
                                <td class="col4">{{ baseinfo.realEndTime }}</td>
                            </tr>
                            
                        </table>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { mapState, mapMutations, mapGetters } from "vuex";
export default {
    name: "landDetail",
    computed: {
        ...mapState({
            isCollapse: (state) => state.isCollapse,
        }),
        ...mapGetters(["isCollapse"]),
    },
    data() {
        return {
            userdata: {},
            yj_itemcode: "A",
            pageType : 1,
            baseinfo: {
                rate:4,
                province: "河北省",
                city: "唐山市",
                county: "",
                projectName: "海上风电法兰二期项目",
                projectLocation: "装备制造园区宏远路南侧",
                ecNumber: "123456",
                nSizeUnit: "58.98",
                source: "",
                bigLandUse: "工矿仓储用地",
                bigSupplyMode: "拍卖出让",
                smallSupplyMode: "",
                useYears: "50",
                smallIndustry: "金属制品业",
                landLevel: "十二级",
                nPriceUnit: "667",
                paymentList: [
                    { number: "1",
                    payTime: "2025/12/9",
                    landOwner: "唐山文丰重工有限公司",
                    memo: "",
                    },
                    { number: "2",
                    payTime: "2026/12/8",
                    landOwner: "唐山文丰重工有限公司",
                    memo: "",
                    },
                    { number: "3",
                    payTime: "2027/12/7",
                    landOwner: "唐山文丰重工有限公司",
                    memo: "",
                    },
                ],
                landOwner: "唐山文丰重工有限公司",
                volumeUpper: "",
                deliveryTime: "2026/12/8",
                startTime: "2027/12/7",
                endTime: "2029/12/6",
                realStartTime: "",
                realEndTime: "",
                approvalCompany: "曹妃甸区人民政府",
                contractTime: "2025/12/9",
                memo: "",
                volumeLower: "0.8",
                investment: "唐山文丰重工有限公司",
                // 其他属性
            },
        };
    },
    created() {
        this.pageType = this.$route.query.pageType?this.$route.query.pageType:1;
        console.log(this.pageType);
    },
    methods: {},
};
</script>
<style lang="scss">
.detail_table {
    border: 1px solid #f2f2f2;
    border-bottom: none;
    background: #fff;
    overflow: hidden;

    th,
    td {
        padding: 0 15px;
        text-align: center;
    }

    th {
        font-size: 16px;
        line-height: 54px;
        height: 54px;
        background: #f2f8fe;
        white-space: nowrap;
    }

    td {
        line-height: 24px;
        border-bottom: 1px solid #eee;
        min-width: 80px;
        font-size: 16px;
        text-align: center;
        padding-top: 8px;
        padding-bottom: 8px;
        max-width: 300px;
        border-right: 1px solid #eee;
        &.font-bold { 
            font-size: 16px;
        }
    }

    tr:hover {
        background: #fcfdff;
    }

    a {
        color: #2a51a4;
    }

    tr td:first-child {
        background: #fcfdff;
    }

    a:hover {
        text-decoration: underline;
        color: #f39800;
    }

    &.table {
        border-top: 1px solid #f2f2f2;
        border-left: 1px solid #f2f2f2;
    }
}

.clueManagement .whitebox {
    min-height: 95vh;
}
</style>